// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"497cf3f5","977":"6693cdca"}[chunkId] + ".chunk.js";
};